@if(isAuthenticated) {
<rh-sidenav [style.height]="'100vh'" [userEmail]="userInfo$ | async" [showDebugTools]="showDebugTools" (loginOutAction)="logout()">
  <router-outlet></router-outlet>
</rh-sidenav>
}@else {
<rh-login [errorMessage]="errorMessage" (loginAction)="login()"></rh-login>
}
